import { MONITORING_SCHEDULE_FALLBACK_TIMEZONES } from './monitoringScheduleConstants';

export interface IMonitoringTimezoneOption {
  id: string,
  label: string,
}

const getSupportedTimezones = (): string[] => {
  if (typeof Intl !== 'undefined' && 'supportedValuesOf' in Intl) {
    return (Intl as typeof Intl & {
      supportedValuesOf: (key: 'timeZone') => string[],
    }).supportedValuesOf('timeZone');
  }

  return MONITORING_SCHEDULE_FALLBACK_TIMEZONES;
};

export const formatTimezoneOffsetLabel = (timezone: string): string => {
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'shortOffset',
    });
    const offset = formatter.formatToParts(new Date())
      .find((part) => part.type === 'timeZoneName')?.value;

    return offset ? `${timezone} (${offset})` : timezone;
  } catch {
    return timezone;
  }
};

export const getMonitoringTimezoneOptions = (): IMonitoringTimezoneOption[] => {
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneIds = new Set<string>([
    browserTimezone,
    ...MONITORING_SCHEDULE_FALLBACK_TIMEZONES,
    ...getSupportedTimezones(),
  ]);

  return Array.from(timezoneIds)
    .sort((left, right) => left.localeCompare(right))
    .map((timezone) => ({
      id: timezone,
      label: formatTimezoneOffsetLabel(timezone),
    }));
};
